import React from "react";
import { Routes, Route } from "react-router-dom";
import DashboardHome from "../../pages/DashboardHome";
import QuickContacts from "../../pages/QuickContacts";
import ViewEmployeeRegistration from "../../pages/ViewEmployeeRegistration";
import ViewStudentRegistration from "../../pages/ViewStudentRegistration";
import ViewRepresentativeRegistration from "../../pages/ViewRepresentativeRegistration";
import AddOnJobForm from "../../pages/AddOnJobForm";
import ViewJobsAdmin from "../../pages/ViewJobsAdmin";
import JobApplicationsAdmin from "../../pages/JobApplicationsAdmin";
import CandidateProfile from "../../pages/CandidateProfile";
import Employeeapprove from "../../pages/Employeeapprove";
import Studentapprove from "../../pages/Studentapprove";
import Tpoapprove from "../../pages/Tpoapprove";
import Jobposting from "../../pages/Jobposting";
import Boardmembers from "../../pages/Boardmembers";
import Employebenefits from "../Memberbenefits/Employebenefits";
import Studentbenefits from "../Memberbenefits/Studentsbenefits";
import Tpobenefits from "../Memberbenefits/Tpobenefits";
import Blockprofile from "../../pages/Blockprofile";
import Addblockprofile from "../../pages/Addblockprofile";
import Talentsection from './../../pages/Talentsection';
import KnTotalApplication from "../../pages/KnTotalApplication";
import UstTotalApplications from "../../pages/UstTotalApplications";
import GlobalNetworks from './../../pages/GlobalNetworks';
import JfTotalApplications from "../../pages/JfTotalApplications";
import GnTotalApplications from "../../pages/GnTotalApplications";
import KnowledgeSharing from "../../pages/KnowledgeSharing"
import UpdateSkills from "../../pages/UpdateSkills";
import JobsFair from "../../pages/JobsFair";
import AdminBlackProfileView from "../../pages/AdminBlackProfileView";
import JobPreview from "../../pages/JobPreview";
import Adminstudentrespons from "../../pages/Adminstudentrespons";
import Employeejobpost from "../Student/pages/Employeejobpost";
import Adminjobpost from "../../pages/Adminjobpost";
import AdminjobList from "../Student/pages/AdminjobList";
import AdminResponses from "../Student/pages/AdminResponses";
import Adminjobproview from "../../pages/Adminjobproview";
import EmployeejobList from "../Student/pages/EmployeejobList";
import Employeejobproview from "../../pages/Employeejobproview";
import Empresponse from "../../pages/Empresponse";
import GnTotalApplicationsRes from "../../pages/GnTotalApplicationsRes";
import KnTotalApplicationRes from "../../pages/KnTotalApplicationRes";
import UstTotalApplicationsRes from "../Student/pages/UstTotalApplicationsRes";
import JfTotalApplicationsRes from "../../pages/JfTotalApplicationsRes";
import EmpregView from "../Student/pages/EmpregView";
import StudentregView from "../Student/pages/StudentregView";
import TporegView from "../Student/pages/TporegView";
import TpoapproveView from "../Student/pages/TpoapproveView";
import StudentapproveView from "../Student/pages/StudentapproveView";
import EmployeeapproveView from "../Student/pages/EmployeeapproveView";


function DashboardRoutes() {
  return (
    <Routes>
      <Route path="/" element={<DashboardHome />} />
      <Route path="QuickContacts" element={<QuickContacts />} />
      <Route path="ViewEmployeeRegistration" element={<ViewEmployeeRegistration />} />
      <Route path="ViewStudentRegistration" element={<ViewStudentRegistration />} />
      <Route path="ViewRepresentativeRegistration" element={<ViewRepresentativeRegistration />} />
      
      {/* <Route path="AddOnJobForm" element={<AddOnJobForm />} /> */}
      {/* <Route path="/Addjob2" element={<Addjob2 />} />  */}
       {/* <Route path="ViewJobsAdmin" element={<ViewJobsAdmin />} /> */}
      {/* <Route path="JobApplicationsAdmin" element={<JobApplicationsAdmin />} />  */}
       <Route path="CandidateProfile" element={<CandidateProfile />} /> 
      <Route path="EmpregView" element={<EmpregView/>} />
       <Route path="StudentregView" element={<StudentregView/>} />
      <Route path="TporegView" element={<TporegView/>} />
      <Route path="Employeeapprove" element={<Employeeapprove />} />
      <Route path="Studentapprove" element={<Studentapprove />} />
      <Route path="Tpoapprove" element={<Tpoapprove />} />
      <Route path="EmployeeapproveView" element={<EmployeeapproveView/>} />
      <Route path="StudentapproveView" element={<StudentapproveView/>} />
      <Route path="TpoapproveView" element={<TpoapproveView/>} />
      <Route path="Jobposting" element={<Jobposting />} />
      <Route path="JobPreview" element={<JobPreview/>}/>
      <Route path="Adminstudentrespons/:jobId" element={<Adminstudentrespons />} />
      <Route path="Boardmembers" element={<Boardmembers />} />
      <Route path="Employebenefits" element={<Employebenefits />} />
      <Route path="Studentbenefits" element={<Studentbenefits />} />
      <Route path="Tpobenefits" element={<Tpobenefits />} />
      <Route path="Blockprofile" element={<Blockprofile />} />
      <Route path="Addblockprofile" element={<Addblockprofile />} />
      <Route path="AdminBlackProfileView" element={<AdminBlackProfileView />} />
      <Route path="Talentsection" element={<Talentsection />} />
       <Route path="GlobalNetworks" element={<GlobalNetworks/>} />
       <Route path="GnTotalApplications" element={<GnTotalApplications/>} />
       <Route path="GnTotalApplicationsRes/:jobId" element={<GnTotalApplicationsRes/>} />
      <Route path="KnowledgeSharing" element={<KnowledgeSharing/>} />
      <Route path="KnTotalApplication" element={<KnTotalApplication/>} />
      <Route path="KnTotalApplicationRes/:jobId" element={<KnTotalApplicationRes  />} />
       <Route path="UpdateSkills" element={<UpdateSkills/>} />
       <Route path="UstTotalApplications" element={<UstTotalApplications/>} />
       <Route path="UstTotalApplicationsRes/:jobId" element={<UstTotalApplicationsRes/>} />
       <Route path="JfTotalApplications" element={<JfTotalApplications/>} />
        <Route path="JfTotalApplicationsRes/:jobId" element={<JfTotalApplicationsRes/>} />
       <Route path="JobsFair" element={<JobsFair/>} />
       <Route path="/Employeejobpost" element={<Employeejobpost/>} />
       <Route path="/Empresponse/:jobId" element={<Empresponse/>} />
       <Route path="/EmployeejobList" element={<EmployeejobList/>} />
       <Route path="/Employeejobproview/:id" element={<Employeejobproview/>} />
       <Route path="/AdminjobList" element={<AdminjobList/>} />
       <Route path="/Adminjobpost" element={<Adminjobpost/>} />
       <Route path="/AdminResponses/:jobId" element={<AdminResponses/>} />
       <Route path="/Adminjobproview/:id" element={<Adminjobproview/>} />
      <Route path="Studentbenefits" element={<Studentbenefits />} />
      <Route path="Tpobenefits" element={<Tpobenefits />} />
       
    </Routes>
  );
}

export default DashboardRoutes;
